import React from 'react';
import { Content, ShimmerEffect } from './styles.';
import { Header } from '../styles';

// import { Container } from './styles';

const LoadingComponent: React.FC = () => {
  return (
    <>
      <Header>
        <ShimmerEffect className="header-shimmer" />
      </Header>
      <Content>
        <ShimmerEffect className="content-shimmer" />
      </Content>
    </>
  );
};

export default LoadingComponent;
